import React from 'react';
import cn from 'classnames';

export interface DividerProps {
  direction: 'horizontal' | 'vertical';
}

export const Divider: React.FC<DividerProps> = ({ direction }) => {
  return (
    <div
      className={cn({
        'h-full min-w-[.125rem] bg-gray-200': direction === 'vertical',
        'w-full min-h-[.125rem] bg-gray-200': direction === 'horizontal',
      })}
    />
  );
};
